module.exports = __webpack_public_path__ + "4-83.jpg?bf007d1f5d935b9b5c8b609b1b355b5b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4-83.jpg
// module id = 164
// module chunks = 0